"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var useCurrenciesOptions_1 = __importDefault(require("common/hooks/useCurrenciesOptions"));
var lodash_1 = require("lodash");
var actionCell_1 = require("portal/components/Grid/helpers/actionCell");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var header_1 = require("../../../components/header");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
var PRGrid = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch;
    var hasSignature = false;
    var t = (0, react_i18next_1.useTranslation)().t;
    var currenciesOptions = (0, useCurrenciesOptions_1.default)();
    var PRHeader = [
        [
            (0, titleCell_1.TitleCell)({
                title: 'To :',
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_b = state.PRData) === null || _b === void 0 ? void 0 : _b.to,
                inputType: 'textInput',
                path: 'PRData.to',
                colSpan: 4,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t('pr.paymentRequestNo'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_c = state.PRData) === null || _c === void 0 ? void 0 : _c.PRNumber, inputType: 'textInput', path: 'POData.PRNumber', colSpan: 4 }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.from'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_d = state.PRData) === null || _d === void 0 ? void 0 : _d.from,
                colSpan: 10,
                inputType: 'textInput',
                path: 'PRData.from',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.date'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === 'view'
                    ? t('common.date', { date: (0, getDateForCell_1.default)((_e = state === null || state === void 0 ? void 0 : state.PRData) === null || _e === void 0 ? void 0 : _e.date, mode) })
                    : (0, getDateForCell_1.default)((_f = state === null || state === void 0 ? void 0 : state.PRData) === null || _f === void 0 ? void 0 : _f.date, mode),
                colSpan: 10,
                inputType: 'datePicker',
                path: 'PRData.date',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t('pr.inAccordanceWithTheActivitiesAsDefinedInTheRelatedBudgetOfTheProjectDepartmentMentionedBelowWeHerebyRequestIdaOrganizationFinanceDepartmentToMakeTheFollowingDirectPaymentToThePayeeBelow'),
                colSpan: 12,
            }),
        ],
    ];
    // const totalSYR = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'SYR' ? item.transactionAmount : 0
    // )
    // const totalEURO = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'EUR' ? item.transactionAmount : 0
    // )
    // const totalUSD = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'USD' ? item.transactionAmount : 0
    // )
    // const totalTL = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'TRY' ? item.transactionAmount : 0
    // )
    var totalEquivalentAmountInUSD = (0, lodash_1.sumBy)(state.PRItems, function (item) { return item.transactionAmount / item.exchangeRate; });
    var PRPaymentDetails = [
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.totalAmount'), colSpan: 2, textAlign: 'center' }),
            (0, titleCell_1.TitleCell)({ title: t('pr.syr'), colSpan: 1, textAlign: 'center' }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.PRData.totalAmountSYR,
                colSpan: 2,
                inputType: 'numberInput',
                path: 'PRData.totalAmountLocalCurrency',
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_g = state.PRData) === null || _g === void 0 ? void 0 : _g.totalAmountSpellSYR,
                colSpan: 7,
                inputType: 'textInput',
                path: 'PRData.totalAmountSpellSYR',
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.totalAmount'), colSpan: 2, textAlign: 'center' }),
            (0, titleCell_1.TitleCell)({ title: t('pr.euro'), colSpan: 1, textAlign: 'center' }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.PRData.totalAmountEURO,
                colSpan: 2,
                inputType: 'numberInput',
                path: 'PRData.totalAmountEURO',
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_h = state.PRData) === null || _h === void 0 ? void 0 : _h.totalAmountSpellEURO,
                colSpan: 7,
                inputType: 'textInput',
                path: 'PRData.totalAmountSpellEURO',
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.totalAmount'), colSpan: 2, textAlign: 'center' }),
            (0, titleCell_1.TitleCell)({ title: t('pr.usd'), colSpan: 1, textAlign: 'center' }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: state.PRData.totalAmountUSD, colSpan: 2, inputType: 'numberInput', path: 'PRData.totalAmountUSD' }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_j = state.PRData) === null || _j === void 0 ? void 0 : _j.totalAmountSpellUSD,
                colSpan: 7,
                inputType: 'textInput',
                path: 'PRData.totalAmountSpellUSD',
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.totalAmount'), colSpan: 2, textAlign: 'center' }),
            (0, titleCell_1.TitleCell)({ title: t('pr.tl'), colSpan: 1, textAlign: 'center' }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: state.PRData.totalAmountTL, colSpan: 2, inputType: 'numberInput', path: 'PRData.totalAmountTL' }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_k = state.PRData) === null || _k === void 0 ? void 0 : _k.totalAmountSpellTL,
                colSpan: 7,
                inputType: 'textInput',
                path: 'PRData.totalAmountSpellTL',
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.totalEquivalentAmountInUsd'), colSpan: 3, textAlign: 'center' }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: totalEquivalentAmountInUSD && totalEquivalentAmountInUSD !== 0 ? totalEquivalentAmountInUSD.toFixed(2) : 0,
                colSpan: 2,
                inputType: 'text',
                path: 'PRData.totalEquivalentAmountInUSD',
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_l = state.PRData) === null || _l === void 0 ? void 0 : _l.totalEquivalentAmountInUSDSpell,
                colSpan: 7,
                inputType: 'textInput',
                path: 'PRData.totalEquivalentAmountInUSDSpell',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.purposeOfPayment'), colSpan: 3, textAlign: 'center' }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_m = state.PRData) === null || _m === void 0 ? void 0 : _m.purposeOfPayment,
                colSpan: 9,
                inputType: 'textInput',
                path: 'PRData.purposeOfPayment',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
    ];
    var PRSupplierSection = [
        [
            (0, titleCell_1.TitleCell)({
                title: t('pr.payeePleaseProvideAsMuchDetailsAsPossible'),
                colSpan: 3,
                textAlign: 'center',
                rowSpan: 10,
                padding: 10,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.dueDate'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === 'view'
                    ? t('common.date', { date: (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.PRData.dueDate, mode) })
                    : (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.PRData.dueDate, mode),
                colSpan: 8,
                inputType: 'datePicker',
                path: 'PRData.dueDate',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.name'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_o = state.PRData) === null || _o === void 0 ? void 0 : _o.supplierName, colSpan: 8, inputType: 'text' }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.address'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_p = state.PRData) === null || _p === void 0 ? void 0 : _p.supplierAddress, colSpan: 8, inputType: 'text' }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.invoiceNumber'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_q = state.PRData) === null || _q === void 0 ? void 0 : _q.invoiceNumber,
                colSpan: 3,
                inputType: 'textInput',
                path: 'PRData.invoiceNumber',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t('pr.contractPoNo'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_r = state.PRData) === null || _r === void 0 ? void 0 : _r.PONumber, colSpan: 4, inputType: 'text' }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t('pr.paymentModeRequested'),
                colSpan: 2,
                padding: 20,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_s = state.PRData) === null || _s === void 0 ? void 0 : _s.paymentModeRequested,
                colSpan: 7,
                inputType: 'textInput',
                path: 'PRData.paymentModeRequested',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [(0, titleCell_1.TitleCell)({ title: t('pr.forBankTransferOnly'), colSpan: 9, fontSize: 20 })],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.bankName'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_u = (_t = state.PRData) === null || _t === void 0 ? void 0 : _t.supplierBankName) !== null && _u !== void 0 ? _u : '',
                colSpan: 3,
                inputType: 'textArea',
                path: 'PRData.supplierBankName',
            }),
            (0, titleCell_1.TitleCell)({ title: t('pr.branch'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_w = (_v = state.PRData) === null || _v === void 0 ? void 0 : _v.supplierBranch) !== null && _w !== void 0 ? _w : '',
                colSpan: 4,
                inputType: 'textArea',
                path: 'PRData.supplierBranch',
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.accountName'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_y = (_x = state.PRData) === null || _x === void 0 ? void 0 : _x.supplierAccountName) !== null && _y !== void 0 ? _y : '',
                colSpan: 8,
                inputType: 'textArea',
                path: 'PRData.supplierAccountName',
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.ibanNo'), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_0 = (_z = state.PRData) === null || _z === void 0 ? void 0 : _z.supplierIban) !== null && _0 !== void 0 ? _0 : '', colSpan: 8, inputType: 'textArea', path: 'PRData.supplierIban' }),
        ],
    ];
    var PRDestinationOfFund = [
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.destinationOfFundPleaseProvideAsMuchDetailsAsPossible'), colSpan: 3, rowSpan: 2 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.preparedByLogistics'), colSpan: 3 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.country'), colSpan: 3 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.office'), colSpan: 3 }),
        ],
        [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_1 = state.PRData) === null || _1 === void 0 ? void 0 : _1.preparedByLogistics,
                inputType: 'textInput',
                path: 'PRData.preparedByLogistics',
                colSpan: 3,
                rowSpan: 1,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_2 = state.PRData) === null || _2 === void 0 ? void 0 : _2.destinationCountry,
                inputType: 'textInput',
                path: 'PRData.destinationCountry',
                colSpan: 3,
                rowSpan: 1,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_3 = state.PRData) === null || _3 === void 0 ? void 0 : _3.destinationOffice,
                inputType: 'textInput',
                path: 'PRData.destinationOffice',
                colSpan: 3,
                rowSpan: 1,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('pr.note'), colSpan: 3 }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_4 = state.PRData) === null || _4 === void 0 ? void 0 : _4.note, inputType: 'textInput', path: 'PRData.note', colSpan: 9 }),
        ],
    ];
    var PRBody = [
        [(0, titleCell_1.TitleCell)({ title: t('pr.costDistribution'), colSpan: 12, textAlign: 'center' })],
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: t('pr.no'), padding: 20, textAlign: 'center', colSpan: 1 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.projectCode'), padding: 20, textAlign: 'center', colSpan: 2 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.budgetLine'), padding: 20, textAlign: 'center', colSpan: 2 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.paymentDestination'), padding: 20, textAlign: 'center', colSpan: 2 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.transactionCurrency'), padding: 20, textAlign: 'center', colSpan: 1 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.transactionAmount'), padding: 20, textAlign: 'center', colSpan: 1 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.exchangeRate'), padding: 20, textAlign: 'center', colSpan: 1 }),
            (0, titleCell_1.TitleCell)({ title: t('pr.usdAmountOfTransaction'), padding: 20, textAlign: 'center', colSpan: 1 })
        ], (mode === 'view' ? [] : [(0, actionCell_1.actionCell)({ action: 'addRow', payload: 'PRItems' })]), true),
    ];
    var PRItems = (_5 = state.PRItems) === null || _5 === void 0 ? void 0 : _5.map(function (item, idx) {
        var _a;
        var USDAmountOfTransaction = item.transactionAmount / item.exchangeRate;
        return __spreadArray([
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: idx + 1, inputType: 'text', colSpan: 1, path: "PRItems[".concat(idx, "].itemNo") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.projectCode,
                inputType: 'textInput',
                colSpan: 2,
                path: "PRItems[".concat(idx, "].projectCode"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.budgetLine,
                inputType: 'textInput',
                colSpan: 2,
                path: "PRItems[".concat(idx, "].budgetLine"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.paymentDestination,
                inputType: 'textInput',
                colSpan: 2,
                path: "PRItems[".concat(idx, "].paymentDestination"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.transactionCurrencyId,
                viewValue: (_a = currenciesList_1.globalCurrenciesData[item.transactionCurrencyId]) === null || _a === void 0 ? void 0 : _a.name,
                inputType: 'select',
                selectData: currenciesOptions,
                path: "PRItems[".concat(idx, "].transactionCurrencyId"),
                required: state.triedSubmitting,
                colSpan: 1,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.transactionAmount,
                inputType: 'numberInput',
                colSpan: 1,
                path: "PRItems[".concat(idx, "].transactionAmount"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.exchangeRate,
                inputType: 'numberInput',
                colSpan: 1,
                path: "PRItems[".concat(idx, "].exchangeRate"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: USDAmountOfTransaction && USDAmountOfTransaction !== 0 ? USDAmountOfTransaction.toFixed(2) : 0,
                inputType: 'text',
                colSpan: 1,
                path: "PRItems[".concat(idx, "].USDAmountOfTransaction"),
            })
        ], (mode === 'view' ? [] : [(0, actionCell_1.actionCell)({ action: 'delete', payload: idx })]), true);
    });
    var approvalCell = function (approvalType, requiredApprovalType) {
        var _a, _b, _c;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        var requiredApproval = (_b = state.approvalsData) === null || _b === void 0 ? void 0 : _b.find(function (e) {
            return e.approvalType === requiredApprovalType;
        });
        if (approval) {
            return (0, valueByMode_1.ValueByMode)({
                mode: 'view',
                value: (_c = usersList_1.globalUsersData[approval.userId]) === null || _c === void 0 ? void 0 : _c.name,
                colSpan: 2,
                rowSpan: 2,
            });
        }
        else if ((requiredApproval &&
            state.PRData.status !== 'approved' &&
            state.PRData.status !== 'cancelled' &&
            state.PRData.status !== 'completed' &&
            state.PRData.status !== 'draft' &&
            state.PRData.status !== 'singedAndArchived') ||
            (!requiredApprovalType &&
                state.PRData.status !== 'approved' &&
                state.PRData.status !== 'cancelled' &&
                state.PRData.status !== 'completed' &&
                state.PRData.status !== 'draft' &&
                state.PRData.status !== 'singedAndArchived')) {
            return {
                action: 'Approve',
                payload: approvalType,
                text: t('cba.approve'),
                confirmMessage: t('alerts.areYouSureYouWantToApproveThisDocument'),
                confirmAction: true,
                type: 'button',
                colSpan: 2,
                rowSpan: 2,
            };
        }
        else {
            return (0, emptyCell_1.emptyCell)({
                colSpan: 2,
                rowSpan: 2,
            });
        }
    };
    function approvals(state, t) {
        var getApproval = function (approvalType) {
            var _a;
            var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
                return e.approvalType === approvalType;
            });
            return approval;
        };
        var approvingDate = function (approvalType) {
            var approval2 = getApproval(approvalType);
            var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
            return t('common.date', { date: date === null || date === void 0 ? void 0 : date.toDate() });
        };
        var approvingSig = function (approvalType) {
            var approval2 = getApproval(approvalType);
            var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
            return sig;
        };
        return [
            [
                (0, titleCell_1.TitleCell)({ title: t('pr.requestedBy'), colSpan: 6, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('pr.authorizedBy'), colSpan: 6, rowSpan: 1 }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: t('dn.name'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.sign'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.date'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.name'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.sign'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.date'), colSpan: 2, rowSpan: 1 }),
            ],
            [
                approvalCell('requestedBy'),
                (0, valueCell_1.ValueCell)({ value: ' ', img: hasSignature && approvingSig('requestedBy'), colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: approvingDate('requestedBy'), colSpan: 2, rowSpan: 2 }),
                approvalCell('authorizedBy', 'requestedBy'),
                (0, valueCell_1.ValueCell)({ value: ' ', img: hasSignature && approvingSig('authorizedBy'), colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: approvingDate('authorizedBy'), colSpan: 2, rowSpan: 2 }),
            ],
            [],
            [
                (0, titleCell_1.TitleCell)({ title: "IMPORTANT: 1. All actual and potential conflicts of interests must be disclosed to Independent Doctors Association directly to the employee’s supervisor or to Human Resources whenever a conflict arises. By signing this document Independent Doctors Association staff attests:- they or their immediate family members have no personal relationship with listed vendors or their employees, - no interest or financial gain or any other type of Conflict of Interest related to this procurement- to have not been employed by any of the vendors from solicitation previously.   2. Concerning that,  all tax responsibility that may be raised is the supplier’s liability.", colSpan: 12, backgroundColor: '#fff' }),
            ]
        ];
    }
    var donorId = (_6 = projectsList_1.globalProjectsData[state.PRData.projectId]) === null || _6 === void 0 ? void 0 : _6.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: 'image', src: (_7 = donorsList_1.globalDonorsData[donorId]) === null || _7 === void 0 ? void 0 : _7.logo, height: 50, colSpan: 4, textAlign: 'center' });
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            (0, IRGrid_1.logoHeader)({ projectId: (_8 = state.PRData) === null || _8 === void 0 ? void 0 : _8.projectId, idaLogo: miLogo, title: t('pr.paymentRequest'), colSpan: 4 })
        ], PRHeader, true), PRPaymentDetails, true), PRSupplierSection, true), PRDestinationOfFund, true), PRBody, true), PRItems, true), approvals(state, t), true),
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: __assign({}, state.PRData), dispatch: dispatch, type: "PR", orderRef: collectionsRef_1.PRsRef.doc(state.PRId) }), (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                    dispatch({
                        type: 'buttonClick',
                        data: {
                            action: action,
                            payload: payload,
                        },
                    });
                }, onValueUpdate: function (path, newValue) {
                    dispatch({
                        type: 'update',
                        payload: {
                            path: path,
                            newValue: newValue,
                        },
                    });
                }, grid: gridData })] }));
};
exports.PRGrid = PRGrid;
exports.default = exports.PRGrid;
